import { z } from "zod";

export const product = z.object({
  status: z.string().optional(),
});

const offerCategory = z
  .union([z.literal("MOBILE"), z.literal("MOBILE_POSTPAID")])
  .optional();

export const group = z.object({
  id: z.string().optional(),
  members: z.array(
    z.object({
      id: z.string().optional(),
      primaryMsisdn: z.string().optional(),
      selectedMsisdn: z.string().optional(),
      products: z.array(product).optional(),
      offerCategory,
    }),
  ),
  metadata: z.object({
    capacity: z.number().optional(),
    capacityDetails: z
      .array(
        z.object({
          offerCategory: offerCategory,
          capacity: z.number().optional(),
          maxCapacity: z.number().optional(),
        }),
      )
      .optional(),
  }),
});

export const serverResponse = z.array(group);

export type IProduct = z.infer<typeof product>;
export type IGroup = z.infer<typeof group>;
